// This file was generated with AI assistance and manually reviewed.
import {backendSingularKind, getBidirectionalRelationKinds} from '../record_building/record_keys'

export const reconcileRelationships = ({previousState, nextState, kind, records}) => {
	const relationKinds = getBidirectionalRelationKinds(kind)
	if (!relationKinds.length) return nextState

	const recordsByKind = new Map()
	const changedKinds = new Set()

	const getRecordsById = kind => {
		if (!recordsByKind.has(kind)) {
			recordsByKind.set(kind, new Map(nextState[kind].map(record => [record.id, record])))
		}
		return recordsByKind.get(kind)
	}

	const updateInverse = ({kind, id, inverseField, sourceId, add}) => {
		const recordsById = getRecordsById(kind)
		const record = recordsById.get(id)
		if (!Array.isArray(record?.[inverseField])) return

		const inverseIds = record[inverseField]
		if (inverseIds.includes(sourceId) === add) return

		const updatedIds = add ? [...inverseIds, sourceId] : inverseIds.filter(id => id !== sourceId)
		recordsById.set(id, {...record, [inverseField]: updatedIds})
		changedKinds.add(kind)
	}

	const previousRecords = previousState[kind] || []
	const inverseField = `${backendSingularKind(kind)}_ids`

	records.forEach(record => {
		const previousRecord = previousRecords.find(item => item.id === record.id)

		relationKinds.forEach(relatedKind => {
			if (!nextState[relatedKind]) return
			const field = `${backendSingularKind(relatedKind)}_ids`
			const previousIds = previousRecord ? previousRecord[field] : []
			const incomingIds = record[field]
			if (!Array.isArray(previousIds) || !Array.isArray(incomingIds)) return

			previousIds
				.filter(id => !incomingIds.includes(id))
				.forEach(id => updateInverse({kind: relatedKind, id, inverseField, sourceId: record.id, add: false}))
			incomingIds
				.filter(id => !previousIds.includes(id))
				.forEach(id => updateInverse({kind: relatedKind, id, inverseField, sourceId: record.id, add: true}))
		})
	})

	if (!changedKinds.size) return nextState

	const changedRecords = {}
	changedKinds.forEach(kind => {
		changedRecords[kind] = [...recordsByKind.get(kind).values()]
	})
	return {...nextState, ...changedRecords}
}
